import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CustomerSupportSvg = function CustomerSupportSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3.678a4.83 4.83 0 0 0-3.453 1.464 5.06 5.06 0 0 0-1.43 3.536v8.333H2V9.868h3.72v-1.19c0-1.705.662-3.34 1.84-4.546A6.2 6.2 0 0 1 12 2.249c1.665 0 3.262.677 4.44 1.883a6.5 6.5 0 0 1 1.84 4.546v1.19H22v7.143h-3.776a4.56 4.56 0 0 1-1.24 2.485 4.4 4.4 0 0 1-2.426 1.268v1.485H9.442v-4.286h5.116v1.345a3 3 0 0 0 1.44-.823c.567-.58.886-1.367.886-2.188v-7.62a5.06 5.06 0 0 0-1.43-3.535A4.83 4.83 0 0 0 12 3.678m6.28 11.904v-4.285h2.325v4.285zm-14.885 0v-4.285h2.326v4.285zm7.442 5.238v-1.428h2.326v1.428z",
    clipRule: "evenodd"
  }));
};
export var CustomerSupport = function CustomerSupport(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CustomerSupportSvg
  }));
};